const COOKIE = '_fxs';
const API    = 'https://fenixbegravning-fxs-156340982420.europe-north2.run.app';

function hash(str) {
  var h = 5381;
  for (var i = 0; i < str.length; i++) {
    h = Math.imul(h, 33) ^ str.charCodeAt(i);
  }
  return (h >>> 0).toString(16);
}

function getCookie(name) {
  var match = document.cookie.split('; ').find(r => r.startsWith(name + '='));
  return match ? match.split('=')[1] : undefined;
}

function setCookie(name, value, days) {
  const exp = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${exp}; path=/; SameSite=Lax`;
}

function track(intent) {
  setCookie(COOKIE, hash(intent), 365);
  fetch(API, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ intent: hash(intent), url: window.location.href }),
  }).catch(() => {});
}

function buildPopup() {
  const overlay = document.createElement('div');
  overlay.id = 'fnx-intent-overlay';
  overlay.style.cssText = `
    position:fixed; inset:0; background:rgba(0,0,0,0.4);
    backdrop-filter:blur(6px); -webkit-backdrop-filter:blur(6px);
    display:flex; align-items:center; justify-content:center;
    z-index:99999; font-family:inherit; padding:1rem;
  `;

  overlay.innerHTML = `
    <div style="background:#fff; overflow:hidden; max-width:460px; width:100%; box-shadow:0 8px 32px rgba(0,0,0,0.2); border:2px solid white;">
      <div style="background:#132d3a; padding:24px 28px; text-align:center;">
        <svg width="140" height="39" viewBox="0 0 215 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M79.6519 11.8792H99.6377V15.8763H83.6491V26.8685H98.6384V30.8656H83.6491V45.855H79.6519V11.8792Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M107.682 11.8792H127.668V15.8763H111.679V26.8685H126.669V30.8656H111.679V41.8578H128.168V45.855H107.682V11.8792Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M177.632 11.8792V45.855H173.635V11.8792H177.632Z" fill="white"/>
          <path d="M197.228 28.9582L184.599 11.8792H189.57L199.717 25.594L209.863 11.8792H214.834L202.206 28.9582L214.706 45.855H209.722L199.717 32.324L189.711 45.855H184.727L197.228 28.9582Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M164.392 11.8792V45.855H160.809L140.159 19.0006V45.855H136.162L136.162 11.8792H139.744L160.394 38.7335V11.8792H164.392Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM18.9673 31.6578C19.5795 31.0828 20.0788 30.5038 20.4441 30.0379C20.0788 29.5719 19.5795 28.9929 18.9673 28.418C17.5535 27.0902 15.7516 25.9804 13.7448 25.9804C11.5039 25.9804 9.68733 27.797 9.68733 30.0379C9.68733 32.2787 11.5039 34.0953 13.7448 34.0953C15.7516 34.0953 17.5535 32.9855 18.9673 31.6578ZM23.2682 33.9303C23.0165 33.623 22.7857 33.3306 22.5762 33.0576C22.239 33.4404 21.8499 33.8501 21.4122 34.2611C19.7151 35.855 17.0724 37.6668 13.7448 37.6668C9.53147 37.6668 6.1159 34.2512 6.1159 30.0379C6.1159 25.8245 9.53147 22.409 13.7448 22.409C17.0724 22.409 19.7151 24.2207 21.4122 25.8146C21.8499 26.2256 22.239 26.6353 22.5762 27.0182C23.4505 25.8784 24.7078 24.3881 26.2999 22.893C29.5525 19.8384 34.4174 16.5658 40.4123 16.5658C47.7968 16.5658 53.7936 22.5071 53.8834 29.8703H53.8844L53.8841 29.9541L53.8844 30.0379H53.8833C53.8384 33.7189 52.3151 37.0471 49.8839 39.4507L47.3729 36.9111C49.1717 35.1326 50.29 32.6757 50.3126 29.9545C50.2678 24.5249 45.8524 20.1372 40.4123 20.1372C35.7383 20.1372 31.7141 22.7078 28.7447 25.4964C27.2788 26.873 26.1223 28.2548 25.3329 29.2928C25.123 29.5688 24.9399 29.8194 24.7846 30.0379C25.0935 30.4724 25.5118 31.0332 26.0311 31.6672C27.2752 33.1861 29.0681 35.0875 31.2917 36.6859L29.2072 39.5859C26.6521 37.7492 24.6372 35.6017 23.2682 33.9303Z" fill="white"/>
        </svg>
        <p style="font-size:15px; color:white; opacity:0.8; margin:10px 0 0;">Välkommen till Fenix Begravning</p>
      </div>
      <div style="padding:28px 20px;">
        <h2 style="text-align:center; font-size:22px; font-weight:600; color:#111; margin:0 0 20px; line-height:1.3;">Hur kan vi hjälpa dig?</h2>
        <div style="display:flex; flex-direction:column; gap:12px;">
          <button data-intent="booker" style="border:2px solid #ccc; border-radius:14px; padding:22px 20px; background:#fafafa; cursor:pointer; text-align:left; display:flex; align-items:center; gap:16px; width:100%;">
            <div style="width:52px; height:52px; min-width:52px; background:#e8e8e8; border-radius:12px; display:flex; align-items:center; justify-content:center;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#444" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <span style="font-size:18px; font-weight:500; color:#111;">Jag vill boka en begravning</span>
          </button>
          <button data-intent="other" style="border:2px solid #ccc; border-radius:14px; padding:22px 20px; background:#fafafa; cursor:pointer; text-align:left; display:flex; align-items:center; gap:16px; width:100%;">
            <div style="width:52px; height:52px; min-width:52px; background:#e8e8e8; border-radius:12px; display:flex; align-items:center; justify-content:center;">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#444" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M12 16v-4M12 8h.01"/>
              </svg>
            </div>
            <span style="font-size:18px; font-weight:500; color:#111;">Jag är här av en annan anledning</span>
          </button>
        </div>
      </div>
    </div>
  `;

  overlay.querySelectorAll('button[data-intent]').forEach(btn => {
    btn.addEventListener('click', () => {
      const intent = btn.dataset.intent;
      track(intent);
      overlay.remove();
      document.body.style.overflow = '';
      if (typeof fenix !== 'undefined' && fenix.intent) {
        fenix.intent.set(intent);
      }
    });
  });

  return overlay;
}

document.addEventListener('DOMContentLoaded', () => {
  if (getCookie(COOKIE)) return;
  if (new URLSearchParams(window.location.search).get('fxs') !== '1') return;
  document.body.appendChild(buildPopup());
  document.body.style.overflow = 'hidden';
});